import Vue from 'vue';
import { Money } from '@razlet/utils';

const REQUIRED_TYPES = ['tax', 'fare', 'penalty'];

const KG_BASIS_TYPES = ['GROSS', 'CHARGE'];
const PC_BASIS_TYPES = ['FIXED', 'FIX'];

export default class PricingDetalizationItem {
  data = null;

  type = null;

  selected = false;

  disabled = false;

  constructor (data, type) {
    this.data = data;
    this.type = type;

    this.selected = REQUIRED_TYPES.includes(type);
    this.disabled = REQUIRED_TYPES.includes(type);
  }

  get isFare () {
    return this.type === 'fare';
  }

  get isPenalty () {
    return this.type === 'penalty';
  }

  get name () {
    if (this.isPenalty) return 'Штраф';
    return this.data.description;
  }

  get code () {
    if (this.type === 'fare') return this.data.rateClassCode;
    return this.data.code;
  }

  get basisValue () {
    return this.data.basisValue;
  }

  get basis () {
    return this.data.basis;
  }

  get direction () {
    return `${this.data.originIata}-${this.data.destinationIata}`;
  }

  get foundation () {
    return `${this.basisValue} ${this.foundationUnit}`;
  }

  get foundationUnit () {
    if (KG_BASIS_TYPES.includes(this.basis)) return Vue.prototype.$localize.t('base.kg');
    if (PC_BASIS_TYPES.includes(this.basis)) return Vue.prototype.$localize.t('base.pc');
    return '';
  }

  get value () {
    if (this.data.rate === null) return '';
    return new Money({
      value: this.data.rate,
      currency: this.currency,
    }, { fractionDigits: 2 });
  }

  get total () {
    const value = this.isPenalty && this.data.equivalentAmount !== 0
      ? this.data.equivalentAmount * -1
      : this.data.equivalentAmount;

    return new Money(
      {
        value,
        currency: this.equivalentCurrency,
      },
      { fractionDigits: 2 }
    );
  }

  get currency () {
    return this.data.currencyCode;
  }

  get equivalentCurrency () {
    return this.data.equivalentCurrencyCode;
  }

  get fullName () {
    return `${this.name} ${this.isFare ? this.direction : ''} ${this.code ? `(${this.code})` : ''}`;
  }

  get info () {
    return this.data.info;
  }
};
